import React from 'react';
import moment from 'moment';

export const FxTimeDisplay = (props:any) => {

    const getTimeDisplay = () => {
        let getDate = props.value;
        if(getDate) {
            const dateDisplay = moment(getDate).format('HH:MM:SS');
            return dateDisplay;
        }
    }

    return(
        <span>
          {getTimeDisplay()}
        </span>       
    );
};